<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <a-radio-group
        name="radioGroup"
        v-model="reference"
        :default-value="1"
        @change="onSwitch"
      >
        <a-radio :value="1">
          {{ $t('wholesale.quotation') }}
        </a-radio>
        <a-radio :value="2">
          {{ $t('wholesale.saleContract') }}
        </a-radio>
      </a-radio-group>
    </div>
    <a-select
      v-model="model.quotation_id"
      :options="quotationList"
      showSearch
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      @change="onFindQuotation"
      class="ts-w-full"
      v-if="reference == 1"
    ></a-select>
    <a-select
      v-model="model.contract_id"
      :options="saleContractList"
      @change="onFindSaleContract"
      showSearch
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      class="ts-w-full"
      v-if="reference == 2"
    ></a-select>
    <small class="ts-mt-2">{{
      $t('wholesale.createInvoiceFromQuotationOrSaleContract')
    }}</small>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'referenceNumber',
  props: ['value', 'validate'],
  data() {
    return {
      reference: 1,
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.setReference()
    this.fetchQuotation()
  },
  computed: {
    ...mapState('wholesale/operation', [
      'quotations',
      'salecontracts',
      'edit_data',
      'customers'
    ]),
    quotationList() {
      return this.quotations.map(el => ({
        value: el.quotation_id,
        label: el.quotation_no
      }))
    },
    saleContractList() {
      return this.salecontracts.map(el => ({
        value: el.contract_id,
        label: el.contract_no
      }))
    },
    thbRate () {
      let foundFx = this.$store.state.wholesale.operation.exchangeRate.find(
        e => e.to_currency == 'THB'
      )
      if (foundFx) {
        return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
      }
      return 0
    }
  },
  methods: {
    ...mapActions('wholesale/operation', [
      'getQuotation',
      'getSalecontract',
      'findQuotation',
      'findSaleContract',
      'getCustomer',
      'getProductInventory'
    ]),
    fetchQuotation() {
      this.$emit('loading', true)
      this.getQuotation().finally(() => {
        this.$emit('loading', false)
      })
    },
    fetchSaleContract() {
      this.$emit('loading', true)
      this.getSalecontract().finally(() => {
        this.$emit('loading', false)
      })
    },
    onSwitch() {
      this.$emit('clearInput')
      if (this.reference == 1) {
        this.fetchQuotation()
      } else {
        this.fetchSaleContract()
      }
    },
    onFindQuotation(value) {
      if (value) {
        this.$emit('loading', true)
        this.findQuotation(value)
          .then(async response => {
            return this.setDataQuotation(response.data)
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      } else {
        this.$emit('clearInput')
      }
    },
    onFindSaleContract(value) {
      if (value) {
        this.$emit('loading', true)
        this.findSaleContract(value)
          .then(async response => {
            return this.setDataSaleContract(response.data)
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      } else {
        this.$emit('clearInput')
      }
    },
    async setDataQuotation(data) {
      if (data) {
        // clear product in state before push new product on change
        let credit = this.customers.find(c => c.customer_id == data.customer_id)
        this.$store.commit('wholesale/operation/SET_PRODUCT', [])
        this.model.customer_id = data.customer_id
        this.model.sub_total = data.total_exclude_vat
        this.model.vat_rate = data.vat_rate
        this.model.vat_amount = data.vat_amount
        this.model.grand_total = data.grand_total
        this.model.quotation_id = data.quotation_id
        this.model.amount_due = data.grand_total
        this.model.reference_no = data.quotation_no
        this.model.amount_deposit = 0
        this.model.contract_id = null
        this.model.credit_day = credit ? credit.credit_day : 0
        this.model.product_detail = []
        data.details.forEach(el => {
          // push product to stat be able to change uom to get new price
          this.$store.commit('wholesale/operation/SET_PRODUCT', {
            uom_cat_id: el.product.uom_cat_id,
            product_id: el.product_id,
            sale_code: el.sale_code,
            uom_category: el.product.uom_category
          })

          // push to model in detail list
          this.model.product_detail.push({
            product_id: el.product_id,
            product_name_en: el.product_name_en,
            product_name_kh: el.product_name_kh,
            barcode: el.barcode,
            uom_id: el.uom_id,
            quantity: el.quantity,
            amount_in_bath: el.unit_price,
            amount_in_kh: el.unit_price * this.model.fx_rate_khr,
            unit_price: el.unit_price * this.model.fx_rate,
            discount_type: '%',
            discount_rate: 0,
            discount_amount: 0,
            total_after_discount: 0,
            vat_rate: 0,
            vat_amount: 0,
            grand_total: _.round(el.quantity * el.unit_price, 2),
            promo_ref_promo_product_id: null,
            promo_type_id: null,
            serial_list: [],
            is_custom: false,
            has_serial: el.is_generate_unique_serial,
            ending_balance: 0
          })
        })
        return this.fetchProductInventory()
      }
    },
    async setDataSaleContract(data) {
      // clear product in state before push new product on change
      this.$store.commit('wholesale/operation/SET_PRODUCT', [])

      this.$store.commit('wholesale/operation/PUSH_NEW_CUSTOMER', {
        customer_id: data.customer_id,
        customer_name: data.customer.customer_name,
        credit_amount: data.credit_amount,
        credit_day: data.credit_day
      })

      let credit = this.customers.find(c => c.customer_id == data.customer_id)
      this.model.customer_id = data.customer_id
      this.model.sub_total = data.total_exclude_vat
      this.model.vat_rate = data.vat_rate
      this.model.vat_amount = data.vat_amount
      this.model.grand_total = data.grand_total
      this.model.amount_due = data.grand_total
      this.model.quotation_id = null
      this.model.reference_no = data.contract_no
      this.model.amount_deposit = data.deposit_amount
      this.model.credit_day = data ? credit.credit_day : 0
      this.model.seller_id = data.seller_id
      this.model.product_detail = []
      data.details.forEach(el => {
        // push product to stat be able to change uom to get new price
        this.$store.commit('wholesale/operation/SET_PRODUCT', {
          uom_cat_id: el.product.uom_cat_id,
          product_id: el.product_id,
          sale_code: el.sale_code,
          uom_category: el.product.uom_category
        })

        // push to model in detail list
        this.model.product_detail.push({
          product_id: el.product_id,
          product_name_en: el.product_name_en,
          barcode: el.barcode,
          uom_id: el.uom_id,
          quantity: el.quantity,
          amount_in_bath: el.unit_price * this.thbRate,
          unit_price: el.unit_price,
          discount_type: '%',
          discount_rate: 0,
          discount_amount: 0,
          total_after_discount: 0,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: el.quantity * el.unit_price,
          promo_ref_promo_product_id: null,
          promo_type_id: null,
          serial_list: [],
          is_custom: false,
          has_serial: el.is_generate_unique_serial,
          balance: 'N/A',
          ending_balance: 0
        })
      })
      return this.fetchProductInventory()
    },
    setReference() {
      if (!_.isEmpty(this.edit_data)) {
        if (this.edit_data.quotation_id) {
          this.reference = 1
          this.$store.commit('wholesale/operation/SET_QUOATION_LIST', [
            {
              quotation_id: this.edit_data.quotation_id,
              quotation_no: this.edit_data.reference_no
            }
          ])
        }
        if (this.edit_data.contract_id) {
          this.reference = 2
          this.$store.commit('wholesale/operation/SET_SALECONTRACT_LIST', [
            {
              contract_id: this.edit_data.contract_id,
              contract_no: this.edit_data.reference_no
            }
          ])
        }
      }
    },
    async fetchProductInventory() {
      this.$emit('loading', true)
      return this.getProductInventory({
        productId: this.model.product_detail.map(p => p.product_id),
        stock_out_date: this.model.stock_out_date
      })
        .then(response => {
          const endingProduct = response.data
          this.model.product_detail.forEach(el => {
            if (endingProduct.hasOwnProperty(el.product_id)) {
              if (endingProduct[el.product_id].length) {
                el.ending_balance = parseFloat(
                  endingProduct[el.product_id][0].ending_balance
                )
              } else {
                el.ending_balance = 0
              }
            } else {
              el.ending_balance = 0
            }
          })
          return response
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>
